import React from 'react';
import { Pagination } from 'antd';

export const LCPagination = props => <Pagination {...props} />;
